import Vue from "vue"
import Notification from "@/shared/notification"

const initNotification = (el) => {
  const { type, message, cookie, can_close: canClose } = JSON.parse(el.dataset.config || "{}")

  new Vue({
    name: "NotificationsInit",
    el,
    components: {
      Notification
    },
    data() {
      return {
        type,
        message,
        cookie,
        canClose,
        show: true
      }
    },
    methods: {
      close() {
        this.show = false
      }
    },
    template: `
      <notification :type="type" :cookie="cookie" :can-close="canClose" :show="show" @close="close">
        <div v-html="message" />
      </notification>
    `
  })
}

document.querySelectorAll(".vue-notification").forEach(initNotification)
